var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshBlue = function SvgRefreshBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.159 5.416h4.368v-.001M.75 13.996v-4.16m0 0h4.369m-4.369 0 2.783 2.652a7.3 7.3 0 0 0 3.237 1.779c3.851.983 7.81-1.194 8.841-4.861M1.666 5.846C2.698 2.18 6.656.004 10.506.987c1.271.324 2.371.951 3.238 1.778l2.783 2.651m0-4.159v4.159"
  })));
};
export { SvgRefreshBlue as ReactComponent };
export default __webpack_public_path__ + "bca0cd6c1588067c58df7c5a9e7719ad.svg";